<template>
  <div class="yxtbiz-as-guage-container">
    <div class="yxtbiz-as-guage-container__guage" :style="{height: `${this.height}px`}">
      <div :id="this.shapeId"></div>
    </div>
    <div class="yxtbiz-as-guage-container__guage-hide" :style="{height: `${this.height * 0.14}px`}"></div>
  </div>
</template>
<script>

export default {
  props: {
    uniqueKey: {
      type: String,
      default: '1'
    },
    height: {
      type: Number,
      default: 79
    },
    rate: {
      type: Number,
      default: 0
    },
    rateName: {
      type: String,
      default: ''
    }
  },
  created() {
    this.shapeId = 'ote_gauge_' + this.uniqueKey;
  },
  mounted() {
    this.getGauge();
  },
  watch: {
    rate: function() {
      this.getGauge();
    }
  },
  methods: {
    getGauge() {
      const { Chart, registerShape } = window.G2;
      document.getElementById(this.shapeId).innerHTML = '';
      const guageHeight = this.height * 1.36;
      const circleLineWith = guageHeight / 10;
      const maxScore = 100;
      // 处理底下被遮去的百分比
      const score = this.rate + (maxScore / 2 - this.rate) / 15;

      const data = [{ value: score }];
      const chart = new Chart({
        container: this.shapeId,
        autoFit: true,
        height: guageHeight,
        padding: [0, 0, 0, 0]
      });
      chart.data(data);

      chart.coordinate('polar', {
        startAngle: (-10 / 9) * Math.PI,
        endAngle: (1 / 9) * Math.PI,
        radius: 0.75
      });
      chart.scale('value', {
        min: 0,
        max: maxScore
      });

      chart.axis('1', false);
      chart.axis('value', {
        line: null,
        label: {
          offset: -circleLineWith * 1.2,
          formatter: (val) => {
            // if (val === '2.25') {
            //   return '差'
            // } else if (val === '3.75') {
            //   return '中'
            // } else if (val === '5.25') {
            //   return '良'
            // }

            // return '优'
            return '';
          },
          style: {
            fontSize: 18,
            textAlign: 'center'
          }
        },
        tickLine: null,
        grid: null
      });
      chart.legend(false);
      // 灰背景
      chart.annotation().arc({
        top: false,
        start: [0, 0.96],
        end: [maxScore, 0.96],
        style: {
          stroke: '#FAFAFA',
          lineWidth: circleLineWith * 2.4,
          lineDash: null
        }
      });
      // 绘制仪表盘背景
      chart.annotation().arc({
        top: false,
        start: [0, 1],
        end: [maxScore, 1],
        style: {
          stroke: '#D9D9D9',
          lineWidth: circleLineWith,
          lineDash: null
        }
      });
      // 绘制指标
      chart.annotation().arc({
        top: false,
        start: [0, 1],
        end: [data[0].value, 1],
        style: {
          stroke: 'l(0) 0:#2F5AFF 1:#4F92FF ',
          lineWidth: circleLineWith,
          lineDash: null
        }
      });
      // 自定义指针Shape
      registerShape('point', 'pointer', {
        draw(cfg, container) {
          const group = container.addGroup({});
          // 获取极坐标系下画布中心点
          const center = this.parsePoint({ x: 0, y: 0 });
          // 绘制指针
          group.addShape('line', {
            attrs: {
              x1: center.x,
              y1: center.y,
              x2: center.x + (cfg.x - center.x) * 2,
              y2: center.y + (cfg.y - center.y) * 2,
              stroke: '#fff',
              lineWidth: guageHeight / 24,
              lineCap: 'round',
              shadowColor: '#F0F0F0',
              shadowBlur: guageHeight / 20
            }
          });
          group.addShape('circle', {
            attrs: {
              x: center.x,
              y: center.y,
              r: guageHeight / 3.5,
              stroke: cfg.color,
              lineWidth: 0,
              fill: '#fff',
              shadowColor: '#F0F0F0',
              shadowBlur: guageHeight / 20
            }
          });

          return group;
        }
      });
      // 绘制中心指针
      chart
        .point()
        .position('value*1')
        .shape('pointer');

      const scorePerUnit = maxScore / 12;
      // 绘制仪表盘刻度线
      for (let index = 1; index < 12; index++) {
        chart.annotation().line({
          start: [scorePerUnit * index + scorePerUnit * (6 - index) / 12, 0.97],
          end: [scorePerUnit * index + scorePerUnit * (6 - index) / 12, 1.03],
          style: {
            stroke: '#fff', // 线的颜色
            lineDash: null, // 虚线的设置
            lineWidth: circleLineWith / 6
          }
        });
      }

      // 绘制指标数字
      chart.annotation().text({
        position: ['50%', '50%'],
        content: `${this.rate}%`,
        style: {
          fontSize: guageHeight * 0.15,
          fill: '#262626',
          textAlign: 'center',
          shadowBlur: 0,
          stroke: null,
          shadowColor: null
        },
        offsetY: 15
      });
      chart.annotation().text({
        position: ['50%', '80%'],
        content: this.rateName,
        style: {
          fontSize: guageHeight * 0.125,
          fill: '#8C8C8C',
          textAlign: 'center',
          shadowBlur: 0,
          stroke: null,
          shadowColor: null
        }
      });

      chart.render();
    }
  }
};
</script>
